import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TransferModal from "../../../components/Modal/Admin/InventoryManagement/Transfer";
import ViewTransfer from "../../../components/Modal/Admin/InventoryManagement/ViewTransfer";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Oval } from "react-loader-spinner";

export default function TransferPage() {
    const [Transfer, setTransfer] = useState([]);
    const [pagination, setPagination] = useState({});
    const [filter, setFilter] = useState("");
    const [showTransfer, setShowTransfer] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [viewTransfer, setViewTransfer] = useState([]);

    useEffect(() => {
        const fetchTransfer = async () => {
            setLoading(true);

            try {
                const response = await axiosInstance.get(
                    `/user/transfer/fetch_transfers`,
                    {
                        params: {
                            page,
                            filter,
                        },
                    }
                );

                setTransfer(response.data.data.transfer.data || []);
                setPagination(response.data.data.transfer);
            } catch (error) {
                toast.error("Error fetching users:", error);
            }
            finally {
                setLoading(false); // Hide loader after fetching
            }
        };

        fetchTransfer();
    }, [page, filter, refreshKey]);

    const handleShowTransfer = () => setShowTransfer(true);

    const handleClose = () => {
        setShowTransfer(false);
        setShow(false);
    };
    const handleRefresh = () => {
        setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= pagination.last_page) {
            setPage(newPage);
        }
    };

    const handleShow = (item) => {
        setViewTransfer(item);
        setShow(true);

    };

    useEffect(() => { }, [refreshKey]);

    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
                            Transfer Management
                        </h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item">
                                    <Link to="/app">Dashboard</Link>
                                </li>
                                <li
                                    className="breadcrumb-item active"
                                    style={{ color: "#c4281c" }}
                                >
                                    Transfer Management
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {loading && !filter ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "80vh" }}
                >
                    <Oval
                        height={80}
                        width={80}
                        color="#FF0200"
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            ) : (

                <div className="row" id="contactList">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center border-0">
                                <h5
                                    className="card-title mb-0 flex-grow-1"
                                    style={{ color: "#c4281b" }}
                                >
                                    Transfer Management
                                </h5>
                            </div>

                            <div className="d-flex justify-content-end">
                                <div className="col-xl-2 col-md-4">
                                    <button
                                        className="vehicle-button btn btn-secondary"
                                        onClick={handleShowTransfer}
                                    >
                                        <i className="mdi mdi-plus-circle-outline"></i> Transfer
                                    </button>
                                </div>
                            </div>

                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="d-flex justify-content-between">
                                    <div className="col-xl-4 col-md-6">
                                        <div className="search-box">
                                            <input
                                                type="text"
                                                className="form-control search"
                                                placeholder="Search product..."
                                                value={filter}
                                                onChange={handleFilterChange}
                                            />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="table-responsive table-card">
                                    <table
                                        className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                                        id="customerTable"
                                    >
                                        <thead className="table-light text-muted">
                                            <tr>
                                                <th scope="col">#</th>
                                                <th>Originating Warehouse</th>
                                                <th>Category</th>
                                                <th>Sub category</th>
                                                <th>Product</th>
                                                <th>Quantity</th>
                                                <th>Destination Warehouse</th>
                                                <th>Action</th>

                                            </tr>
                                        </thead>
                                        {/* <!--end thead--> */}
                                        <tbody className="list form-check-all">
                                            {Transfer.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td scope="row">{index + 1}</td>
                                                    <td>{item.from_warehouse}</td>
                                                    <td>{item.from_category}</td>
                                                    <td>{item.from_sub_category}</td>
                                                    <td>{item.from_product_name}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.to_warehouse}</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="mdi mdi-apps"></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <Link
                                                                        className="dropdown-item"
                                                                        onClick={() => handleShow(item)}
                                                                    >
                                                                        <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                                                                        View Transfer
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {/* <!--end table--> */}
                                        <div className="d-flex mt-5 mb-5 flex-wrap">
                                            <div className="pagination-wrap hstack gap-2 mx-auto">
                                            <ul className="pagination listjs-pagination mb-0">
                                                {(pagination.links || []).map((link, index) => {
                                                    const pageNumber = link.url
                                                        ? new URL(link.url).searchParams.get("page")
                                                        : null;

                                                    return (
                                                        <li
                                                            key={index}
                                                            className={`page-item ${link.active ? "active" : ""
                                                                }`}
                                                        >
                                                            <button
                                                                className="page-link"
                                                                onClick={() =>
                                                                    pageNumber &&
                                                                    handlePageChange(Number(pageNumber))
                                                                }
                                                                dangerouslySetInnerHTML={{ __html: link.label }}
                                                            ></button>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            )}

            <TransferModal
                showTransfer={showTransfer}
                closeModal={handleClose}
                refreshPage={handleRefresh}
            />
            <ViewTransfer
                show={show}
                closeModal={handleClose}
                transfer={viewTransfer}

            />
        </>
    );
}
